module.exports = __webpack_public_path__ + "static/img/product-7.9609f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-7.png
// module id = PRI/
// module chunks = 0